export default __webpack_public_path__ + "static/media/THE_SCOTSMAN.c1b01568.png";